import {
  CarrierKind,
  ParamsRedirectToHold,
  ResponseRedirectToHoldEligibility,
  ResponseRedirectToHoldEligibilityV,
  RequestRedirectToHoldEligibility,
} from '../../../server/api/schema';

import { decode } from '../../../server/lib/codec';

export interface EligibilityParams {
  carrier: CarrierKind;
  trackingNumber: ParamsRedirectToHold['trackingNumber'];
  request: RequestRedirectToHoldEligibility;
}

const getEligibility = async ({
  carrier,
  trackingNumber,
  request,
}: EligibilityParams): Promise<ResponseRedirectToHoldEligibility> => {
  const url = `/api/v1/delivery-management/${carrier}/redirect-to-hold/${trackingNumber}/eligibility`;

  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return decode(ResponseRedirectToHoldEligibilityV, await response.json());
};

export default getEligibility;
